function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#Preview_svg__filter0_ddd)"
}, React.createElement("rect", {
  x: 7.11,
  y: 5,
  width: 149.781,
  height: 22.308,
  rx: 4.78,
  fill: "#fff"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.264 21.82a5.672 5.672 0 01-5.666-5.666 5.672 5.672 0 015.666-5.665 5.672 5.672 0 015.665 5.665 5.672 5.672 0 01-5.665 5.665zm0-9.915a4.254 4.254 0 00-4.25 4.249 4.254 4.254 0 004.25 4.25 4.254 4.254 0 004.249-4.25 4.254 4.254 0 00-4.25-4.25z",
  fill: "#E1E9F0"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.93 16.154a5.666 5.666 0 00-5.666-5.665.708.708 0 000 1.416 4.25 4.25 0 014.249 4.249.708.708 0 001.416 0z",
  fill: "url(#Preview_svg__paint0_linear)"
}), React.createElement("rect", {
  x: 30.214,
  y: 13.681,
  width: 121.896,
  height: 4.947,
  rx: 2.473,
  fill: "url(#Preview_svg__paint1_linear)"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#Preview_svg__filter1_ddd)"
}, React.createElement("rect", {
  x: 7.11,
  y: 35.346,
  width: 149.781,
  height: 22.308,
  rx: 4.78,
  fill: "#fff"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.264 52.166a5.672 5.672 0 01-5.666-5.666 5.672 5.672 0 015.666-5.665 5.672 5.672 0 015.665 5.665 5.672 5.672 0 01-5.665 5.666zm0-9.915a4.254 4.254 0 00-4.25 4.25 4.254 4.254 0 004.25 4.248 4.254 4.254 0 004.249-4.249 4.254 4.254 0 00-4.25-4.249z",
  fill: "#E1E9F0"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.93 46.5a5.666 5.666 0 00-5.666-5.665.708.708 0 000 1.416 4.25 4.25 0 014.249 4.25.708.708 0 001.416 0z",
  fill: "url(#Preview_svg__paint2_linear)"
}), React.createElement("rect", {
  x: 30.214,
  y: 44,
  width: 121.896,
  height: 5,
  rx: 2.5,
  fill: "url(#Preview_svg__paint3_linear)"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "Preview_svg__paint0_linear",
  x1: 14.369,
  y1: 13.675,
  x2: 20.742,
  y2: 20.049,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E1E9F0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#9BADBC"
})), React.createElement("linearGradient", {
  id: "Preview_svg__paint1_linear",
  x1: -30.734,
  y1: 16.154,
  x2: -30.333,
  y2: 26.031,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E1E9F0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#9BADBC"
})), React.createElement("linearGradient", {
  id: "Preview_svg__paint2_linear",
  x1: 14.369,
  y1: 44.022,
  x2: 20.742,
  y2: 50.395,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E1E9F0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#9BADBC"
})), React.createElement("linearGradient", {
  id: "Preview_svg__paint3_linear",
  x1: -30.734,
  y1: 46.5,
  x2: -30.324,
  y2: 56.483,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E1E9F0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#9BADBC"
})), React.createElement("filter", {
  id: "Preview_svg__filter0_ddd",
  x: 0.736,
  y: 0.22,
  width: 162.528,
  height: 35.055,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", {
  dy: 1.593
}), React.createElement("feGaussianBlur", {
  stdDeviation: 3.187
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.349638 0 0 0 0 0.380478 0 0 0 0 0.407892 0 0 0 0.0960719 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", {
  dy: 0.797
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.797
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.349638 0 0 0 0 0.380478 0 0 0 0 0.407892 0 0 0 0.147645 0"
}), React.createElement("feBlend", {
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feMorphology", {
  radius: 0.797,
  operator: "dilate",
  in: "SourceAlpha",
  result: "effect3_dropShadow"
}), React.createElement("feOffset", null), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.419608 0 0 0 0 0.564706 0 0 0 0 0.752941 0 0 0 0.0486779 0"
}), React.createElement("feBlend", {
  in2: "effect2_dropShadow",
  result: "effect3_dropShadow"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect3_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "Preview_svg__filter1_ddd",
  x: 0.736,
  y: 30.566,
  width: 162.528,
  height: 35.055,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", {
  dy: 1.593
}), React.createElement("feGaussianBlur", {
  stdDeviation: 3.187
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.349638 0 0 0 0 0.380478 0 0 0 0 0.407892 0 0 0 0.0960719 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", {
  dy: 0.797
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.797
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.349638 0 0 0 0 0.380478 0 0 0 0 0.407892 0 0 0 0.147645 0"
}), React.createElement("feBlend", {
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feMorphology", {
  radius: 0.797,
  operator: "dilate",
  in: "SourceAlpha",
  result: "effect3_dropShadow"
}), React.createElement("feOffset", null), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.419608 0 0 0 0 0.564706 0 0 0 0 0.752941 0 0 0 0.0486779 0"
}), React.createElement("feBlend", {
  in2: "effect2_dropShadow",
  result: "effect3_dropShadow"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect3_dropShadow",
  result: "shape"
})));

var SvgPreview = function SvgPreview(props) {
  return React.createElement("svg", _extends({
    width: 164,
    height: 66,
    viewBox: "0 0 164 66",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgPreview;